export class BillingInfo{
    name: string;
    fname: string;
    street1: string;
    zip: number;
    city: string;
    state: string;
    phone1: string;
    phone2: string;
    email1: string;
    email2: string;

    constructor(){
        this.name = '';
        this.fname = '';
        this.street1 = '';
        this.zip = 0;
        this.city = '';
        this.state = '';
        this.phone1 = '';
        this.phone2 = '';
        this.email1 = '';
        this.email2 = '';
    }
}